export const MESSAGETEMPLATESELECTDATA = 'MESSAGETEMPLATESELECTDATA'
export const TEMPLATESELECTDATA = 'TEMPLATESELECTDATA'
export const SETTITLEDATA = 'SETTITLEDATA'
export const SETPHONEMESSAGEDATA = 'SETPHONEMESSAGEDATA'
export const SETSMSMESSAGEDATA = 'SETSMSMESSAGEDATA'
export const SETEMAILMESSAGEDATA = 'SETEMAILMESSAGEDATA'
export const SETENGLISHPOSITIVERESPONSEDATA = 'SETENGLISHPOSITIVERESPONSEDATA'
export const SETENGLISHNEGATIVERESPONSEDATA = 'SETENGLISHNEGATIVERESPONSEDATA'
export const SETSPANISHPOSITIVERESPONSEDATA = 'SETSPANISHPOSITIVERESPONSEDATA'
export const SETSPANISHNEGATIVERESPONSEDATA = 'SETSPANISHNEGATIVERESPONSEDATA'
export const FETCH = 'FETCH'
export const SELECTIONDATA = 'SELECTIONDATA'
